import { StateStorage } from "zustand/middleware";

const store: Record<string, string> = {};

/**
 * Storage for Zustand that does not persist data.
 */
const zustandNoopStorage: StateStorage = {
	setItem: (name, value) => {
		store[name] = value;
	},
	getItem: (name) => {
		return store[name] ?? null;
	},
	removeItem: (name) => {
		delete store[name];
	},
};

export default zustandNoopStorage;
